import React from 'react';
import { Grid } from '@mui/material';


const ExtraImg = ({ extraImages }) => {
    const { img1, img2, img3 } = extraImages;
    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={4}>
                <div className="extra-image">
                    <img src={img1} alt="img1" />
                </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
                <div className="extra-image">
                    <img src={img2} alt="img2" />
                </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
                <div className="extra-image">
                    <img src={img3} alt="img3" />
                </div>
            </Grid>
        </Grid>
    );
};

export default ExtraImg;